import React from 'react'
import { Button ,Modal, ModalBody, ModalHeader, ModalFooter,Row, Col, ListGroup, ListGroupItem } from 'reactstrap';
import { Dialog } from "primereact/dialog";

export const ModalReleaseExamMicrobiology = (props) => {

    const {
        releaseExam, modalReleaseExam, toggleRelease, loadingReleaseExam,
        saveUpdateStatusComplete
    } = props;

      const criticalEmpty =
        !releaseExam.exams_transports &&
        !releaseExam.production_cost &&
        !releaseExam.valid_method_default &&
        !releaseExam.valid_analyte &&
        !releaseExam.valid_analyte_age_gender_range &&
        !releaseExam.valid_number_projections;

    const footer = (
        <div className="flex justify-content-end gap-2">

             <Button size="sm" outline color="primary" type="button" className={loadingReleaseExam ? "disabled progress-bar-animated progress-bar-striped" : ""} onClick={saveUpdateStatusComplete}
                    disabled={ (releaseExam.exams_transports || releaseExam.production_cost || releaseExam.valid_method_default || releaseExam.valid_analyte || releaseExam.valid_analyte_age_gender_range || releaseExam.valid_number_projections ) ? true : false }
                >
                    Liberar examen
            </Button>
            <Button size="sm" className="btn-air-light" outline color='danger' type="button" onClick={toggleRelease}>Cancelar</Button>
        </div>
    );


    return (
        <Dialog
            header="Liberar examen"
            visible={modalReleaseExam}
            modal
            dismissableMask={false} 
            closable
            onHide={toggleRelease}
            footer={footer}
            className='medium-dialog'
            headerStyle={{
                backgroundColor: "#0d3b59",
                color: "white",
                fontWeight: "bold"
            }}
            contentStyle={{ fontSize: "11px" }}
        >
                <Row>
                    <Col md="12">
                        <b className='text-danger'>Configuración Requerida</b>                        
                    </Col>
                    <Col md="12">
                        <ListGroup>
                            {
                                (releaseExam.exams_transports || releaseExam.production_cost || releaseExam.valid_method_default || releaseExam.valid_analyte || releaseExam.valid_analyte_age_gender_range || releaseExam.valid_number_projections) 
                                    ? "" 
                                    : 
                                        <ListGroupItem className="d-flex justify-content-between align-items-center list-group-item-action">
                                            No hay indicaciones criticas
                                            <i className="fa fa-check text-success"></i>
                                        </ListGroupItem>
                            }
                            {  //!releaseExam.enable_analyte_configuration modifique esta parte
                                (releaseExam.is_imagenology && releaseExam.enable_analyte_configuration)
                                ?
                                    <ListGroupItem className="d-flex justify-content-between align-items-center list-group-item-action list-group-item-danger">
                                        { releaseExam.valid_number_projections ?  <strong>Falta añadir el número de proyecciones para este examen</strong> : "" }
                                        <i className="fa fa-exclamation-triangle text-danger"></i>
                                    </ListGroupItem>
                                
                                : ""
                            }
                            {
                                releaseExam.exams_transports ? 
                                    <ListGroupItem className="d-flex justify-content-between align-items-center list-group-item-action list-group-item-danger">
                                        { releaseExam.exams_transports ? <strong>  Falta añadir un tipo de transporte</strong> : "" }
                                        <i className="fa fa-exclamation-triangle text-danger"></i>
                                    </ListGroupItem>
                                    : ""
                            }
                            {
                                releaseExam.production_cost ? 
                                    <ListGroupItem className="d-flex justify-content-between align-items-center list-group-item-action list-group-item-danger">
                                        { releaseExam.production_cost ? <strong>Falta añadir un costo de producción </strong>  : "" }
                                        <i className="fa fa-exclamation-triangle text-danger"></i>
                                    </ListGroupItem>
                                    : ""
                            }
                            {
                                releaseExam.valid_method_default ? 
                                    <ListGroupItem className="d-flex justify-content-between align-items-center list-group-item-action list-group-item-danger">
                                        { releaseExam.valid_method_default ? <strong>Falta añadir un metodo por defecto </strong>: "" }
                                        <i className="fa fa-exclamation-triangle text-danger"></i>
                                    </ListGroupItem>
                                    : ""
                            }
                            {
                                releaseExam.valid_analyte ? 
                                    <ListGroupItem className="d-flex justify-content-between align-items-center list-group-item-action list-group-item-danger">
                                        { releaseExam.valid_analyte ? <strong>Falta añadir al menos un analito</strong>  : "" }
                                        <i className="fa fa-exclamation-triangle text-danger"></i>
                                    </ListGroupItem>
                                    : ""
                            }
                            {
                                releaseExam.valid_analyte_age_gender_range ? 
                                    <ListGroupItem className="d-flex justify-content-between align-items-center list-group-item-action list-group-item-danger">
                                        { releaseExam.valid_analyte_age_gender_range ? <strong>Falta añadir al menos un rango de edad  </strong> : "" }
                                        <i className="fa fa-exclamation-triangle text-danger"></i>
                                    </ListGroupItem>
                                    : ""
                            }
                        </ListGroup>
                        <br />
                        <b className=''>Indicaciones preventivas</b>
                        <ListGroup>
                            {
                                releaseExam.valid_reference_values ? 
                                    <ListGroupItem className="d-flex justify-content-between align-items-center list-group-item-action list-group-item-warning">

                                        { releaseExam.valid_reference_values ? "Falta añadir al menos un valor de referencia" : "" }
                                        <i className="fa fa-exclamation-triangle text-warning"></i>
                                    </ListGroupItem>
                                    : ""
                            }
                            {
                                releaseExam.valid_indications ? 
                                    <ListGroupItem className="d-flex justify-content-between align-items-center list-group-item-action list-group-item-warning">
                                        { releaseExam.valid_indications ? "Falta añadir al menos una indicación" : "" }
                                        <i className="fa fa-exclamation-triangle text-warning"></i>
                                    </ListGroupItem>
                                    : ""
                            }   
                        </ListGroup>                                                 
                    </Col>
                </Row>  
                <br />
                <Row>
                    <Col md="12">
                        <b>* Para librar el examen para su venta, completa primero las indicaciones criticas</b>
                    </Col>
                </Row>
            
        </Dialog>
            // <ModalFooter>
                // <Button size="sm" outline color="primary" type="button" className={loadingReleaseExam ? "disabled progress-bar-animated progress-bar-striped" : ""} onClick={saveUpdateStatusComplete}
                //     disabled={ (releaseExam.exams_transports || releaseExam.production_cost || releaseExam.valid_method_default || releaseExam.valid_analyte || releaseExam.valid_analyte_age_gender_range || releaseExam.valid_number_projections ) ? true : false }
                // >
                //     Liberar examen
                // </Button>
                // <Button size="sm" className="btn-air-light" outline color='danger' type="button" onClick={toggleRelease}>Cancelar</Button>
            // </ModalFooter>
    ) 
}
